<template>
  <header class="navbar-fixed" :class="{ fixed, scrolled: isScrolled }">
    <nav>
      <div class="nav-wrapper">
        <a href="/" class="brand-logo">
          <PictureImg
            src="/images/landing/rasylva-logo-white"
            alt="Rasylva Logo White"
            :extensions="['svg', 'webp', 'png']"
            :lazy="false"
            :img-style="{ width: '80px', display: 'block' }"
          />
        </a>

        <ul class="desktop-menu">
          <li><a href="/" :class="{ active: isActiveRoute('/') }">Home</a></li>
          <li><a href="/about" :class="{ active: isActiveRoute('/about') }">About Us</a></li>
          <li
            class="has-dropdown"
            @mouseenter="toggleDropdown('products')"
            @mouseleave="closeDropdowns"
            @keydown.escape="closeDropdowns"
          >
            <button
              type="button"
              class="dropdown-trigger"
              :class="{
                active: activeDropdown === 'products' || isActiveRoute('/products') || isActiveRoute('/beecounter'),
              }"
              aria-haspopup="true"
              :aria-expanded="activeDropdown === 'products'"
            >
              Products
              <svg
                class="dropdown-arrow"
                :class="{ rotated: activeDropdown === 'products' }"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 4.5L6 8L9.5 4.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <ul class="dropdown-menu" :class="{ visible: activeDropdown === 'products', top: !isScrolled }">
              <li>
                <a
                  href="/products/inventum"
                  :class="{ active: isActiveRoute('/products/inventum') }"
                  @click="closeDropdowns"
                  >Inventum</a
                >
              </li>
              <li>
                <!-- eslint-disable-next-line vue/max-attributes-per-line -->
                <a href="/beecounter" :class="{ active: isActiveRoute('/beecounter') }" @click="closeDropdowns"
                  >BeeCounter</a
                >
              </li>
            </ul>
          </li>
          <li><a href="/services/web-app" :class="{ active: isActiveRoute('/services') }">Service</a></li>
          <li class="contact-btn-wrapper">
            <a
              href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
              class="contact-btn"
              :class="{ top: !isScrolled }"
              target="_blank"
              rel="noreferrer"
              >Contact Us</a
            >
          </li>
        </ul>

        <div ref="fullMenuTrigger" class="full-menu-trigger" @click="toggleFullMenu"></div>
        <div ref="fullMenuOverlay" class="full-menu-overlay" @click="toggleFullMenu"></div>
        <div ref="fullMenu" class="full-menu" :class="{ top: !isScrolled }">
          <ul>
            <li class="divider mb-4"></li>
            <li><a href="/#home" :class="{ active: isActiveRoute('/') }" @click="toggleFullMenu">Home</a></li>
            <li><a href="/about" :class="{ active: isActiveRoute('/about') }" @click="toggleFullMenu">About Us</a></li>
            <li class="mobile-has-dropdown">
              <button
                type="button"
                class="mobile-dropdown-trigger"
                :class="{ active: isActiveRoute('/products') || isActiveRoute('/beecounter') }"
                aria-haspopup="true"
                :aria-expanded="activeDropdown === 'products'"
                @click="toggleDropdown('products')"
              >
                Products
                <svg
                  class="mobile-dropdown-arrow"
                  :class="{ rotated: activeDropdown === 'products' }"
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 4.5L6 8L9.5 4.5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <ul class="mobile-dropdown-menu" :class="{ open: activeDropdown === 'products' }">
                <li>
                  <a
                    href="/products/inventum"
                    :class="{ active: isActiveRoute('/products/inventum') }"
                    @click="toggleFullMenu"
                  >
                    Inventum
                  </a>
                </li>
                <li>
                  <a href="/beecounter" :class="{ active: isActiveRoute('/beecounter') }" @click="toggleFullMenu">
                    BeeCounter
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <!-- eslint-disable-next-line vue/max-attributes-per-line -->
              <a href="/services/web-app" :class="{ active: isActiveRoute('/services') }" @click="toggleFullMenu"
                >Service</a
              >
            </li>
            <li>
              <a
                href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
                target="_blank"
                rel="noreferrer"
                @click="toggleFullMenu"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import PictureImg from '~/components/picture-img';

export default {
  components: {
    PictureImg,
  },
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isScrolled: false,
      activeDropdown: null,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.querySelector('main')?.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.querySelector('main')?.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleFullMenu() {
      this.$refs.fullMenuTrigger.classList.toggle('opened');
      this.$refs.fullMenuOverlay.classList.toggle('opened');
      this.$refs.fullMenu.classList.toggle('opened');
      this.closeDropdowns();
    },
    handleScroll() {
      this.isScrolled = document.querySelector('main')?.scrollTop > 10 || window.scrollY > 10;
    },
    toggleDropdown(name) {
      this.activeDropdown = this.activeDropdown === name ? null : name;
    },
    closeDropdowns() {
      this.activeDropdown = null;
    },
    handleClickOutside(event) {
      const desktopMenu = this.$el.querySelector('.desktop-menu');
      const fullMenu = this.$el.querySelector('.full-menu');
      const isInsideDesktopMenu = desktopMenu && desktopMenu.contains(event.target);
      const isInsideFullMenu = fullMenu && fullMenu.contains(event.target);
      if (!isInsideDesktopMenu && !isInsideFullMenu) {
        this.closeDropdowns();
      }
    },
    isActiveRoute(path) {
      const currentPath = this.$route?.path || window.location.pathname;
      if (path === '/') {
        return currentPath === '/';
      }
      return currentPath.startsWith(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/variables';

.navbar-fixed {
  &.fixed {
    position: fixed;
    nav {
      background: rgba(200, 200, 200, 0.25);
      backdrop-filter: blur(4px);
      box-shadow: 0px 4px 10px rgba(100, 100, 100, 0.2);
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      transition: background-color 0.4s ease-in-out;
    }
  }
  &.scrolled {
    nav {
      background: $rasylva-green;
    }
  }
  nav {
    background: $rasylva-green;
    .brand-logo {
      z-index: 100;
      top: 55%;
      left: 20px;
      transform: translate(0, -50%);
    }
  }
}

.desktop-menu {
  display: none;
  @media only screen and (min-width: 993px) {
    display: flex;
    align-items: center;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 24px;
  }
  > li {
    position: relative;
    padding: 0px 16px;
    > a {
      color: white;
      font-size: 15px;
      font-weight: 700;
      text-decoration: none;
      transition: opacity 0.2s ease;
      display: inline;
      padding: 8px 12px;
      border-radius: 8px;
      &:hover,
      &.active {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .has-dropdown {
    position: relative;
  }
  .dropdown-trigger {
    align-items: center;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    font-family: inherit;
    font-size: 15px;
    font-weight: 700;
    gap: 6px;
    padding: 8px 16px;
    transition: opacity 0.2s ease;
    display: inline;
    padding: 8px 12px;
    border-radius: 8px;
    &:hover,
    &.active {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .dropdown-arrow {
    transition: transform 0.2s ease;
    &.rotated {
      transform: rotate(180deg);
    }
  }
  .dropdown-menu {
    background: $rasylva-green;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    left: 50%;
    list-style: none;
    margin: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 100%;
    transform: translateX(-50%) translateY(-8px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    visibility: hidden;
    z-index: 100;
    &.top {
      background: rgba(200, 200, 200, 0.25);
      backdrop-filter: blur(4px);
      box-shadow: 0px 4px 10px rgba(100, 100, 100, 0.2);
      border: 1px solid rgba(0, 0, 0, 0.05);
    }
    &.visible {
      opacity: 1;
      pointer-events: auto;
      transform: translateX(-50%) translateY(0);
      visibility: visible;
    }
    li {
      width: 100%;
      a {
        color: white;
        display: block;
        font-size: 14px;
        line-height: 4;
        font-weight: 700;
        padding: 0px 20px;
        text-decoration: none;
        transition: background-color 0.15s ease;
        &:hover,
        &.active {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
  .contact-btn-wrapper {
    margin-left: 8px;
  }
  .contact-btn {
    padding: 8px 16px !important;
    border-radius: 24px;
    color: $rasylva-green;
    background: white;
    transition: color 0.2s ease, background-color 0.2s ease;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      color: white;
    }
    &.top {
      color: black;
      &:hover {
        color: white;
      }
    }
  }
}

.full-menu {
  background: $rasylva-green;
  border-radius: 0 0 0 50%;
  height: auto;
  opacity: 0;
  visibility: hidden;
  padding: 0px;
  position: fixed;
  right: -48px;
  transition: all 0.4s ease-in-out;
  width: 100vw;
  z-index: 1;
  text-align: center;
  @media only screen and (min-width: 993px) {
    display: none;
  }
  > ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    > li > a {
      color: white;
      font-weight: 700;
      padding: 8px 16px;
      transition: opacity 0.2s ease;
      display: inline;
      padding: 8px 12px;
      border-radius: 8px;
      &:hover,
      &.active {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .mobile-has-dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 0;
  }
  .mobile-dropdown-trigger {
    align-items: center;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-weight: 700;
    padding: 8px 16px;
    display: inline;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 8px;
    transition: background-color 0.2s ease;
    &:hover,
    &.active {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .mobile-dropdown-arrow {
    transition: transform 0.25s ease;
    &.rotated {
      transform: rotate(180deg);
    }
  }
  .mobile-dropdown-menu {
    display: flex;
    flex-direction: column;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    &.open {
      max-height: 200px;
      padding: 8px 0;
    }
    li a {
      color: white;
      display: inline;
      font-size: 15px;
      line-height: 2;
      font-weight: 400;
      padding: 8px 12px;
      border-radius: 8px;
      text-decoration: none;
      transition: background-color 0.15s ease;
      opacity: 0.85;
      &:hover,
      &.active {
        background-color: rgba(0, 0, 0, 0.1);
        opacity: 1;
      }
    }
  }
  &.opened {
    border-radius: 0;
    height: auto;
    opacity: 1;
    visibility: visible;
    right: 0;
    width: 100vw;
    padding: 55px 0;
  }
  &-overlay {
    background: black;
    border-radius: 0;
    height: 0;
    height: 100vh;
    height: calc((var(--vh, 1vh) * 100));
    opacity: 0;
    position: fixed;
    transition: all 0.4s ease-in-out;
    visibility: hidden;
    width: 100vw;
    @media only screen and (min-width: 993px) {
      display: none;
    }
    &.opened {
      opacity: 0.5;
      visibility: visible;
    }
  }
  &-trigger {
    background: transparent;
    height: 23px;
    position: absolute;
    right: 20px;
    top: 16px;
    width: 30px;
    cursor: pointer;
    @media only screen and (min-width: 600px) {
      top: 20px;
    }
    @media only screen and (min-width: 993px) {
      display: none;
    }
    &:before,
    &:after {
      background: white;
      backface-visibility: hidden;
      content: '';
      height: 2.4px;
      left: 0;
      transition: 0.75s;
      width: 30px;
    }
    &:before {
      box-shadow: white 0 10px 0 0;
      position: absolute;
      top: 0;
    }
    &:after {
      position: absolute;
      top: calc(100% - 2px);
    }
    &.opened {
      position: fixed;
      z-index: 100;
      &:before,
      &:after {
        background: white;
      }
      &:before {
        box-shadow: transparent 0 0 0 0;
        top: 50%;
        transform: rotate(-225deg);
      }
      &:after {
        top: 50%;
        transform: rotate(-315deg);
      }
    }
  }
}
</style>
